const GraphReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_GRAPH':
            return {"topologies": action.payload};
        default:
            return state;
    }
}

export default GraphReducer;